
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useEvent } from '../eventHooks';
/**
 * Returns true if the event has the participant list feature enabled
 * @param {number} eventId
 */
export function useParticipantsListEnabled(eventId) {
    const event = useEvent(eventId);
    return useMemo(() => !event.settings.disable_participants_list, [event.settings]);
}

